import { z } from "zod"

import {
  visitExecutionPlanConfigureV1Schema,
} from "./field-visit-execution-v1.js"

export const visitExecutionPlanConfigureV2Schema =
  visitExecutionPlanConfigureV1Schema.safeExtend({
    requiresPerformedScope: z.boolean(),
    requiresCompletionEvidence: z.boolean(),
    requiresCustomerAcknowledgment: z.boolean(),
  }).strict()

export type VisitExecutionPlanConfigureV2 = z.infer<
  typeof visitExecutionPlanConfigureV2Schema
>
